import { useFormikContext } from "formik";
import React, { FC, useEffect, useState } from "react";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useLocale } from "../../../contexts/localeContext";
import { MultiSelectOption } from "../../../models/MultiSelectOption";
import { getBuildingNamesWithPagination } from "../../../services/buildingService";
import { getCategoryNameWithPagination } from "../../../services/categoryService";
import { getCompanyNamesWithPagination } from "../../../services/companyService";
import { getControllerNamesWithPagnation } from "../../../services/controllerService";
import { getDepartmentNamesWithPagination } from "../../../services/departmentService";
import { WizardSummaryLayout } from '../../wizard/wizard-summary-layout';
import { getEnrolmentNamesWithPagination } from "../../../services/enrolmentService";
import { getFloorsNamesWithPagination } from "../../../services/floorService";
import { getReaderNamesWithPagination } from "../../../services/readerService";
import { getSiteNamesWithPagination } from "../../../services/siteService";
import { getZoneNamesWithPagination } from "../../../services/zoneService";
import { appendFilter } from "../../../utilities/filters";

interface SummaryProps {
    onBack: (event: any) => void;
    type: string;
}

const Summary: FC<SummaryProps> = ({ onBack, type }) => {
    const { translate } = useLocale();
    const { values, setFieldValue } = useFormikContext<any>();
    const [selectedItems, setSelectedItems] = useState<MultiSelectOption[]>([]);
    const [entityName, setEntityName] = useState<string>("");

    useEffect(() => {
        getFilterWithNames();
    }, [values.filterIds])

    const getFilterWithNames = async () => {
        try {
            let names: MultiSelectOption[] = [];

            switch (type) {
                case "controller":
                    names = (await getControllerNamesWithPagnation({ filters: appendFilter(values.filterIds?.toString(), "Entity", "id", [], "=in=") })).rows;
                    setEntityName(translate.byKey(TranslationKeys.controllers));
                    break;
                case "zone":
                    names = (await getZoneNamesWithPagination({ filters: appendFilter(values.filterIds?.toString(), "Entity", "id", [], "=in=") })).rows;
                    setEntityName(translate.byKey(TranslationKeys.zones));
                    break;
                case "reader":
                    names = (await getReaderNamesWithPagination({ filters: appendFilter(values.filterIds?.toString(), "Entity", "id", [], "=in=") })).rows;
                    setEntityName(translate.byKey(TranslationKeys.readers));
                    break;
                case "building":
                    names = (await getBuildingNamesWithPagination({ filters: appendFilter(values.filterIds?.toString(), "Entity", "id", [], "=in=") })).rows;
                    setEntityName(translate.byKey(TranslationKeys.buildings));
                    break;
                case "floor":
                    names = (await getFloorsNamesWithPagination({ filters: appendFilter(values.filterIds?.toString(), "Entity", "id", [], "=in=") })).rows;
                    setEntityName(translate.byKey(TranslationKeys.floors));
                    break;
                case "company":
                    names = (await getCompanyNamesWithPagination({ filters: appendFilter(values.filterIds?.toString(), "Entity", "id", [], "=in=") })).rows;
                    setEntityName(translate.byKey(TranslationKeys.company));
                    break;
                case "department":
                    names = (await getDepartmentNamesWithPagination({ filters: appendFilter(values.filterIds?.toString(), "Entity", "id", [], "=in=") })).rows;
                    setEntityName(translate.byKey(TranslationKeys.department));
                    break;
                case "profileName":
                    names = (await getCategoryNameWithPagination({ filters: appendFilter(values.filterIds?.toString(), "Entity", "id", [], "=in=") })).rows;
                    setEntityName(translate.byKey(TranslationKeys.category));
                    break;
                case "site":
                    names = (await getSiteNamesWithPagination({ filters: appendFilter(values.filterIds?.toString(), "Entity", "id", [], "=in=") })).rows;
                    setEntityName(translate.byKey(TranslationKeys.site));
                    break;
                case "displayName":
                    names = (await getEnrolmentNamesWithPagination({ filters: appendFilter(values.filterIds?.toString(), "Entity", "id", [], "=in=") })).rows;
                    setEntityName(translate.byKey(TranslationKeys.displayName));
                    break;
            }

            setSelectedItems(names);
            setFieldValue("filterNames", names);
            return names;
        } catch (error) {

        }
    }

    return <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.confirm)}>
        <div className="flex flex-col">
            <div className="flex flex-row flex-1">
                <h4 className="p-1 text-xs text-gray-600 w-1/3">{translate.byKey(TranslationKeys.filter)}</h4>
                <div className="flex flex-col w-1/3">
                    <span className="p-1 text-sm">{entityName}</span>
                </div>
            </div>
            
            <div className="flex flex-row flex-1">
                <h4 className="p-1 text-xs text-gray-600 w-1/3">{entityName}</h4>
                <ul className="flex flex-col w-1/3">
                    {selectedItems.map((item: MultiSelectOption) => {
                        { return <li key={item.value} className="p-1 text-sm">{item.label}</li> }
                    })}
                </ul>
            </div>

        </div>
    </WizardSummaryLayout>
}

export default Summary;